/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import type { Location } from 'history';

import { EBreadCrumbType } from '@modules/breadCrumbs/breadCrumbsTypes';

interface ILocationFromConstructor {
    fromConstructor: boolean;
};

function isLocationFromConstructor(locationState: unknown): locationState is ILocationFromConstructor {
    return typeof locationState === 'object' && locationState !== null && 'fromConstructor' in locationState;
};

export const setPageSubscriberIdBreadcrumbs = (
    isReportsConstructorAvailable: boolean,
    location: Location<unknown>,
): EBreadCrumbType[] => {
    if (isReportsConstructorAvailable && isLocationFromConstructor(location.state) && location.state.fromConstructor) {
        return [
            EBreadCrumbType.reportsConstructor,
            EBreadCrumbType.reportsConstructorSubscribers,
            EBreadCrumbType.subscriberMobileInfo,
        ];
    }

    return [EBreadCrumbType.subscriberMobile, EBreadCrumbType.subscriberMobileInfo];
};
